import React from "react";
import "./Copyright.scss";

const Copyright = () => {
  return (
    <footer>
      <div className="cr">
        <p>by Habibfr.</p>
        <p>©2022 All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Copyright;
